// Bugsnag
import '~/plugins/bugsnag'

// Rails UJS
import Rails from '@rails/ujs'
if (!window._rails_loaded) {
  Rails.start()
} // prevent double-load: https://github.com/ElMassimo/jumpstart-vite/commit/f25668a989c3bfd50b9063ee99645771c7a56101#r84401032

// ActiveStorage
import * as ActiveStorage from '@rails/activestorage'
ActiveStorage.start()

// Trix
import Trix from 'trix'
import 'trix/dist/trix.css'
document.addEventListener('trix-before-initialize', () => {
  console.log('Trix loaded!', Trix.config)
})

// FontAwesome
import '@fortawesome/fontawesome-free/css/all.css'

// Turbo
import { Turbo } from '@hotwired/turbo-rails'
/**
 * When a request is sent from inside a Turbo frame, Turbo accepts redirection but still expect to find content to
 * update that frame in the response. To break out of the frame, we can set a `data-turbo-frame="top"` on the form
 * or link that triggers the request. If this built-in solution is not applicable (e.g. because we need to be able
 * to send the user back to the form if there is an error), use this custom Turbo Stream action.
 *
 * @see https://www.ducktypelabs.com/turbo-break-out-and-redirect/
 */
Turbo.StreamActions.redirect = function () {
  Turbo.visit(this.target)
}

// Stimulus
import { Application } from '@hotwired/stimulus'
import { registerControllers } from 'stimulus-vite-helpers'

const stimulus = Application.start()
registerControllers(stimulus, import.meta.glob('~/controllers/**/*_controller.js', { eager: true }))
registerControllers(stimulus, import.meta.glob('~/../components/**/*_controller.js', { eager: true }))

// Misc
import { disableInputScroll } from '~/utils/disable_input_scroll'

const pageInit = () => {
  disableInputScroll()
}
if (document.readyState === 'complete') pageInit()
else document.addEventListener('turbo:load', pageInit)
